
  import {Component, Prop, Vue} from 'vue-property-decorator';
  @Component
  export default class BrowserNotSupported extends Vue {
    @Prop({default: null}) version: number;

    mounted() {}
  }
